import { render, staticRenderFns } from "./SupplierManufacturingHealthSafety.vue?vue&type=template&id=43c72963&scoped=true&"
import script from "./SupplierManufacturingHealthSafety.vue?vue&type=script&lang=js&"
export * from "./SupplierManufacturingHealthSafety.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c72963",
  null
  
)

export default component.exports